import React from 'react';
import classNames from 'classnames';
// common components
import Grid from '../../../../common/components/Grid/Grid';
// local components
import ApplyForm from '../ApplyForm/ApplyForm';
import Footer from '../Footer/Footer';
// styles
import './DesktopFormBlock.css';

interface Props {
  vacancy?: string,
  className?: string;
}

class DesktopFormBlock extends React.Component<Props> {
  
  constructor(props: Props) {
    super(props)
  }
  
  render(): JSX.Element {
    const windowWidth = window.innerWidth;
    const { vacancy, className } = this.props;
    const currentClass: {[key: string]: boolean} = {
      "apply-to-vacancy": true,
    }
    let leftbarGridClass = Grid.itemClass(4);
    let formGridClass = Grid.itemClass(4);
    
    if (className) currentClass[className] = true;
    
    if (windowWidth > 767 && windowWidth < 1024) {
      leftbarGridClass = Grid.itemClass(8);
      formGridClass = Grid.itemClass(8);
    } else if (windowWidth >= 1024 && windowWidth < 1280) {
      leftbarGridClass = Grid.itemClass(3);
      formGridClass = Grid.itemClass(5);
    } else if (windowWidth >= 1280 && windowWidth < 1376) {
      leftbarGridClass = Grid.itemClass(5);
      formGridClass = Grid.itemClass(7);
    } else if (windowWidth >= 1376 && windowWidth < 1920) {
      leftbarGridClass = Grid.itemClass(6);
      formGridClass = Grid.itemClass(6);
    } else if (windowWidth >= 1920) {
      leftbarGridClass = Grid.itemClass(4);
      formGridClass = Grid.itemClass(8);
    }
    
    return (
      <div className={classNames(currentClass)}>
        <div className="container">
          <Grid className="apply-to-vacancy-grid">
            <div className={`left-bar ${leftbarGridClass}`}>
              <div className="mobile-hidden tablet-hidden">
                <span>Мы ждём</span><br/>
                <span>ваших</span><br/>
                <span>рекомендаций!</span>
              </div>
              <div className="tablet-visible hidden">
                <span>Мы ждём ваших рекомендаций!</span>
              </div>
              <div className="mobile-visible hidden">
                <span>Мы ждём ваших</span><br/>
                <span>рекомендаций!</span>
              </div>
            </div>
            <div className={`content ${formGridClass}`}>
              <ApplyForm id="vacancy-apply-form" vacancy={vacancy} key={`referal-form-$[windowWidth]`} />
              <Footer />
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}

export default DesktopFormBlock;
